import step1 from 'assets/images/mobileApp/step1.webp';
import step2 from 'assets/images/mobileApp/step2.webp';
import step3 from 'assets/images/mobileApp/step3.webp';
import step4 from 'assets/images/mobileApp/step4.webp';
import step5 from 'assets/images/mobileApp/step5.webp';

export const slidesData = [step1, step2, step3, step4, step5];
